import React from 'react'
import Project from "../../Project/Project"
const Projectsdiv = () => {
  return (
    <div>
      <Project/>
    </div>
  )
}

export default Projectsdiv